import { DEBUG } from '@src/DEBUG'; 
DEBUG.open ( '/app/root.component.ts' );

import {Component} from '@angular/core';
import {MatIconRegistry} from '@angular/material';
import {AppService} from './commons/app.service';
import {TranslateService} from '@ngx-translate/core';
import { LoadingSpinner } from './commons/ui/loading-spinner';
import { XsIdentityInterface } from './xs/interfaces/identify.interface';
import { Router } from '@angular/router';

@Component({
    selector: 'app-root',
    template: '<div [class]="service.curThemeClass"><router-outlet></router-outlet><ng-snotify></ng-snotify></div>'
})
export class RootComponent implements XsIdentityInterface {

    __ID = null;

    constructor ( public router:Router, mdIconRegistry: MatIconRegistry, public service:AppService, translate: TranslateService ) {

        DEBUG.log( '/app/root.component.ts' );

        this.__ID = XsIdentityInterface.__init(this);

        // console.log ( '%c /app/root.component.ts CONSTRUCTOR', 'color:white;background-color:black;' );

        // when using material, register fontawesome
       // mdIconRegistry.registerFontClassAlias('fontawesome', 'fa')
        // Init translation services
        let codes:string[] = []
        service.languages.forEach(lang => codes.push(lang.code))
        translate.addLangs(codes)
        translate.setDefaultLang('en')

        let browserLang = translate.getBrowserLang()
        // console.log("Browser lang: " + browserLang)
        this.service.language = browserLang;
        translate.use(browserLang.match(/en|es|ja/) ? browserLang : 'en')

        // this bit kicks of a CSS transition from gray to blue background color 
        // (indicating that the framework is loaded, now the app and Vasat stuff needs loading)
        LoadingSpinner.go('app');
    }
}
/*
@Component({
    selector: 'app-root',
    template: '<div id="root" [class]="service.curThemeClass"><router-outlet></router-outlet></div>'
})
export class AppMakerComponent {

    constructor(mdIconRegistry: MatIconRegistry, public service:AppService, translate: TranslateService ) {

        DEBUG.log( '/app/maker.component.ts' );

        let codes:string[] = []
        service.languages.forEach(lang => codes.push(lang.code))
        translate.addLangs(codes)
        translate.setDefaultLang('en')

        let browserLang = translate.getBrowserLang()
        // console.log("Browser lang: " + browserLang)
        this.service.language = browserLang;
        translate.use(browserLang.match(/en|es|ja/) ? browserLang : 'en')

        // this bit kicks of a CSS transition from gray to blue background color 
        // (indicating that the framework is loaded, now the app and Vasat stuff needs loading)
        LoadingSpinner.go('app');
    }
}
*/

@Component({
    selector: 'app-nf',
    template:
    `<div class="row justify-content-center mt-4">
        <div class="col-md-8">
            <div class="d-flex justify-content-center">
            <fa-icon icon="bug" class="fa-5x primary"></fa-icon>
            </div>
            <div class="d-flex justify-content-center">
            <h2 class="align-text-center"> ERROR.PAGE_NOT_FOUND </h2>
            </div>
        </div>
    </div>`
})
export class NotFoundComponent {

    constructor() {
        DEBUG.log( '/app/maker.component.ts', 'NOT FOUND COMPONENT' );
        LoadingSpinner.error();
    }
}
